import { get_unpadded1ygmnwh0rw79t as get_unpadded } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import {
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
  Companion_getInstance1toimxkidoujm as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { asDouble13iw8t97m16nn as asDouble } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function datePeriodInput(_this__u8e3s4, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_0 = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (NumberInput())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_2.willAddChild_hz2iwc_k$(element_0);
  element_0.set_align_ypalx0_k$(Align_End_getInstance());
  element_0.set_keyboardHints_w6k1he_k$(Companion_getInstance().integer_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  element_0.native_1.attributes_1.native_1.placeholder = '0';
  var tmp = datePeriodInput$lambda;
  element_0.bind_gesskf_k$(element_0.content_1, asDouble(value.lens_u4wb4z_k$(tmp, datePeriodInput$lambda_0)));
  element_0.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_0);
  text(get_centered(element), 'years');
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_3 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  var this_4 = themed(this_3, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (NumberInput())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_4.willAddChild_hz2iwc_k$(element_1);
  element_1.set_align_ypalx0_k$(Align_End_getInstance());
  element_1.set_keyboardHints_w6k1he_k$(Companion_getInstance().integer_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  element_1.native_1.attributes_1.native_1.placeholder = '0';
  var tmp_0 = datePeriodInput$lambda_1;
  element_1.bind_gesskf_k$(element_1.content_1, asDouble(value.lens_u4wb4z_k$(tmp_0, datePeriodInput$lambda_2)));
  element_1.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_1);
  text(get_centered(element), 'months');
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_5 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  var this_6 = themed(this_5, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (NumberInput())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_6.willAddChild_hz2iwc_k$(element_2);
  element_2.set_align_ypalx0_k$(Align_End_getInstance());
  element_2.set_keyboardHints_w6k1he_k$(Companion_getInstance().integer_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  element_2.native_1.attributes_1.native_1.placeholder = '0';
  var tmp_1 = datePeriodInput$lambda_3;
  element_2.bind_gesskf_k$(element_2.content_1, asDouble(value.lens_u4wb4z_k$(tmp_1, datePeriodInput$lambda_4)));
  element_2.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_2);
  text(get_centered(element), 'days');
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_7 = themed(element, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Frame())(this_7.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_7.willAddChild_hz2iwc_k$(element_3);
  element_3.onStartup_vrxh3i_k$();
  this_7.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function datePeriodInput$lambda(it) {
  var tmp1_safe_receiver = it == null ? null : it.get_years_j1r3xp_k$();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_0;
    if (!(tmp1_safe_receiver === 0)) {
      tmp_0 = tmp1_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function datePeriodInput$lambda_0(old, it) {
  var tmp = it == null ? 0 : it;
  var tmp2_elvis_lhs = old == null ? null : old.get_months_gqmrjw_k$();
  var tmp_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
  var tmp4_elvis_lhs = old == null ? null : old.days_1;
  var proposed = DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(tmp, tmp_0, tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs);
  return proposed.equals(DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 0)) ? null : proposed;
}
function datePeriodInput$lambda_1(it) {
  var tmp1_safe_receiver = it == null ? null : it.get_months_gqmrjw_k$();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_0;
    if (!(tmp1_safe_receiver === 0)) {
      tmp_0 = tmp1_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function datePeriodInput$lambda_2(old, it) {
  var tmp1_elvis_lhs = old == null ? null : old.get_years_j1r3xp_k$();
  var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp_0 = it == null ? 0 : it;
  var tmp4_elvis_lhs = old == null ? null : old.days_1;
  var proposed = DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(tmp, tmp_0, tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs);
  return proposed.equals(DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 0)) ? null : proposed;
}
function datePeriodInput$lambda_3(it) {
  var tmp1_safe_receiver = it == null ? null : it.days_1;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_0;
    if (!(tmp1_safe_receiver === 0)) {
      tmp_0 = tmp1_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function datePeriodInput$lambda_4(old, it) {
  var tmp1_elvis_lhs = old == null ? null : old.get_years_j1r3xp_k$();
  var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp3_elvis_lhs = old == null ? null : old.get_months_gqmrjw_k$();
  var tmp_0 = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
  var proposed = DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(tmp, tmp_0, it == null ? 0 : it);
  return proposed.equals(DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(0, 0, 0)) ? null : proposed;
}
//region block: exports
export {
  datePeriodInput as datePeriodInput2rxrzbjjw21rh,
};
//endregion

//# sourceMappingURL=datePeriodInput.mjs.map
